import { useState, useEffect } from 'react';

/**
 * Debounce a value by `delay` milliseconds.
 * Returns the debounced value which only updates after the delay has elapsed
 * since the last change — useful for search inputs that trigger API calls.
 */
export function useDebounce(value, delay = 300) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
